import { render } from "./NavTabItem.vue?vue&type=template&id=180ccb05"
import script from "./NavTabItem.vue?vue&type=script&lang=js"
export * from "./NavTabItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__